import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store';
import { showToast } from 'vant';

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/Home/index.vue'),
    meta: {
      title: '首页',
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
    meta: {
      title: '入菲管理',
    },
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/Register/index.vue'),
    meta: {
      title: '注册',
    },
  },
  {
    path: '/user',
    name: 'user',
    component: () => import('@/views/User/index.vue'),
    meta: {
      title: '我的',
    },
  },
  {
    path: '/modifyPassword',
    name: 'modifyPassword',
    component: () => import('@/views/User/modifyPassword.vue'),
    meta: {
      title: '修改密码',
    },
  },
  {
    path: '/enter/:position?',
    name: 'enter',
    component: () => import('@/views/Scan/EnterCode/index.vue'),
    meta: {
      title: '扫码入菲',
    },
  },
  {
    path: '/codeDetail',
    name: 'codeDetail',
    component: () => import('@/views/Scan/EnterCode/detail.vue'),
    meta: {
      title: '扫码入菲',
      comName: 'CodeDetail',
      // needKeepAlivePaths: ['/apply/stopScan', '/apply/production', '/apply/process'],
    },
  },
  {
    path: '/selectProcess',
    name: 'selectProcess',
    component: () => import('@/views/Scan/EnterCode/selectProcess.vue'),
    meta: {
      title: '选择入菲工序',
    },
  },
  {
    path: '/timeError',
    name: 'timeError',
    component: () => import('@/views/Scan/EnterCode/timeError.vue'),
    meta: {
      title: '生产时间异常',
    },
  },
  {
    path: '/notFinishSuccess',
    name: 'notFinishSuccess',
    component: () => import('@/views/Scan/EnterCode/notFinishSuccess.vue'),
    meta: {
      title: '扫码入菲',
    },
  },
  {
    path: '/confirmFinish',
    name: 'confirmFinish',
    component: () => import('@/views/Scan/EnterCode/confirmFinish.vue'),
    meta: {
      title: '扫码入菲',
    },
  },
  {
    path: '/confirmFinishSuccess',
    name: 'confirmFinishSuccess',
    component: () => import('@/views/Scan/EnterCode/confirmFinishSuccess.vue'),
    meta: {
      title: '扫码入菲',
    },
  },
  {
    path: '/apply/:type',
    name: 'apply',
    component: () => import('@/views/Scan/EnterCode/apply.vue'),
    meta: {
      title: '扫码入菲',
      comName: 'ApplyPage',
    },
  },
  {
    path: '/applySuccess',
    name: 'applySuccess',
    component: () => import('@/views/Scan/EnterCode/applySuccess.vue'),
    meta: {
      title: '扫码入菲',
    },
  },
  {
    path: '/codeResult/:type',
    name: 'codeResult',
    component: () => import('@/views/Scan/EnterCode/result.vue'),
    meta: {
      title: '扫码入菲',
    },
  },
  {
    path: '/competentProcess',
    name: 'competentProcess',
    component: () => import('@/views/Scan/EnterCode/userProcess.vue'),
    meta: {
      title: '胜任工序',
    },
  },
  {
    path: '/exception',
    name: 'exception',
    component: () => import('@/views/Scan/EnterCode/exception.vue'),
    meta: {
      title: '处理异常',
    },
  },
  {
    path: '/searchCode',
    name: 'searchCode',
    component: () => import('@/views/Scan/SearchCode/index.vue'),
    meta: {
      title: '扫码查菲',
    },
  },
  {
    path: '/machineCodeDetail',
    name: 'machineCodeDetail',
    component: () => import('@/views/Scan/SearchCode/machineCodeDetail.vue'),
    meta: {
      title: '机器入菲明细',
    },
  },
  {
    path: '/deleteCode',
    name: 'deleteCode',
    component: () => import('@/views/Scan/DeleteCode/index.vue'),
    meta: {
      title: '删除菲',
    },
  },
  {
    path: '/productTask',
    name: 'productTask',
    component: () => import('@/views/Scan/ProductTask/index.vue'),
    meta: {
      title: '生产任务',
    },
  },
  {
    path: '/productTask/free',
    name: 'productTaskFree',
    component: () => import('@/views/Scan/ProductTask/freeIndex.vue'),
    meta: {
      title: '生产任务',
    },
  },
  {
    path: '/productTask/schedule',
    name: 'productTaskSchedule',
    component: () => import('@/views/Scan/ProductTask/scheduleIndex.vue'),
    meta: {
      title: '生产任务',
    },
  },
  {
    path: '/reviewCode',
    name: 'reviewCode',
    component: () => import('@/views/Scan/ReviewCode/index.vue'),
    meta: {
      title: '入菲复核',
      comName: 'ReviewCode',
      needKeepAlivePaths: ['/reviewCode/handleError', '/reviewCode/projectDetail'],
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters.isAdmin) {
        next('/');
        showToast('您没有权限查看，请联系管理员');
      } else {
        next();
      }
    },
  },
  {
    path: '/reviewCode/projectDetail',
    name: 'reviewCodeProjectDetail',
    component: () => import('@/views/Scan/ReviewCode/projectDimension/projectDetail.vue'),
    meta: {
      title: '生产单详情',
      comName: 'ReviewCodeProjectDetail',
      needKeepAlivePaths: ['/reviewCode/bundleDetail', '/reviewCode/handleError'],
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters.isAdmin) {
        next('/');
        showToast('您没有权限查看，请联系管理员');
      } else {
        next();
      }
    },
  },
  {
    path: '/reviewCode/bundleDetail',
    name: 'reviewCodeBundleDetail',
    component: () => import('@/views/Scan/ReviewCode/projectDimension/bundleDetail.vue'),
    meta: {
      title: '入菲明细',
      comName: 'ReviewCodeBundleDetail',
      needKeepAlivePaths: ['/reviewCode/handleError'],
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters.isAdmin) {
        next('/');
        showToast('您没有权限查看，请联系管理员');
      } else {
        next();
      }
    },
  },
  {
    path: '/reviewCode/handleError',
    name: 'handleError',
    component: () => import('@/views/Scan/ReviewCode/handleError.vue'),
    meta: {
      title: '异常产出处理',
      comName: 'HandleError',
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters.isAdmin) {
        next('/');
        showToast('您没有权限查看，请联系管理员');
      } else {
        next();
      }
    },
  },
  {
    path: '/scanAuth',
    name: 'scanAuth',
    component: () => import('@/views/Scan/ScanAuth/index.vue'),
    meta: {
      title: '扫菲授权',
      comName: 'ScanAuth',
      needKeepAlivePaths: ['/authDetail', '/processApplyAuth', '/productApplyAuth'],
    },
  },
  {
    path: '/authDetail',
    name: 'authDetail',
    component: () => import('@/views/Scan/ScanAuth/authDetail.vue'),
    meta: {
      title: '授权详情',
      comName: 'AuthDetail',
    },
  },
  {
    path: '/processApplyAuth',
    name: 'processApplyAuth',
    component: () => import('@/views/Scan/ScanAuth/processApplyAuth.vue'),
    meta: {
      title: '工序申请授权',
      comName: 'ProcessApplyAuth',
    },
  },
  {
    path: '/productApplyAuth',
    name: 'productApplyAuth',
    component: () => import('@/views/Scan/ScanAuth/productApplyAuth.vue'),
    meta: {
      title: '排产申请授权',
      comName: 'ProductApplyAuth',
    },
  },
  {
    path: '/salaryInquiry',
    name: 'salaryInquiry',
    component: () => import('@/views/Search/SalaryInquiry/index.vue'),
    meta: {
      title: '工资查询',
    },
  },
  {
    path: '/salaryInquiry/detail',
    name: 'salaryInquiryDetail',
    component: () => import('@/views/Search/SalaryInquiry/detail/index.vue'),
    meta: {
      title: '工资明细',
    },
  },
  {
    path: '/salaryInquiry/total',
    name: 'salaryInquiryTotal',
    component: () => import('@/views/Search/SalaryInquiry/personSalaryTotal.vue'),
    meta: {
      title: '个人工资汇总',
    },
  },
  {
    path: '/progressInquiry',
    name: 'progressInquiry',
    component: () => import('@/views/Search/ProgressInquiry/index.vue'),
    meta: {
      title: '进度查询',
    },
  },
  {
    path: '/progressInquiry/order',
    name: 'progressInquiryByOrder',
    component: () => import('@/views/Search/ProgressInquiry/byOrderSearch.vue'),
    meta: {
      title: '按订单查询',
      comName: 'ProgressSearchByOrderList',
      needKeepAlivePaths: ['/progressInquiry/orderDetail'],
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters.isAdmin) {
        next('/');
        showToast('您没有权限查看，请联系管理员');
      } else {
        next();
      }
    },
  },
  {
    path: '/progressInquiry/process',
    name: 'progressInquiryByProcess',
    component: () => import('@/views/Search/ProgressInquiry/byProcessSearch.vue'),
    meta: {
      title: '按工序查询',
      comName: 'ProgressSearchByProcessList',
      needKeepAlivePaths: ['/progressInquiry/detail'],
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters.isAdmin) {
        next('/');
        showToast('您没有权限查看，请联系管理员');
      } else {
        next();
      }
    },
  },
  {
    path: '/progressInquiry/bundle',
    name: 'progressInquiryByBundle',
    component: () => import('@/views/Search/ProgressInquiry/byBundleSearch.vue'),
    meta: {
      title: '按明细查询',
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters.isAdmin) {
        next('/');
        showToast('您没有权限查看，请联系管理员');
      } else {
        next();
      }
    },
  },
  {
    path: '/progressInquiry/orderDetail',
    name: 'orderDetail',
    component: () => import('@/views/Search/ProgressInquiry/orderProcessDetail.vue'),
    meta: {
      title: '订单进度详情',
      comName: 'OrderProcessDetail',
      needKeepAlivePaths: ['/progressInquiry/processDetail'],
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters.isAdmin) {
        next('/');
        showToast('您没有权限查看，请联系管理员');
      } else {
        next();
      }
    },
  },
  {
    path: '/progressInquiry/processDetail',
    name: 'processDetail',
    component: () => import('@/views/Search/ProgressInquiry/processDetail.vue'),
    meta: {
      // targetComName: 'OrderProcessDetail',
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters.isAdmin) {
        next('/');
        showToast('您没有权限查看，请联系管理员');
      } else {
        next();
      }
    },
  },
  {
    path: '/progressInquiry/detail',
    name: 'detail',
    component: () => import('@/views/Search/ProgressInquiry/processDetail.vue'),
    meta: {
      // targetComName: 'ProgressSearchByProcessList',
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters.isAdmin) {
        next('/');
        showToast('您没有权限查看，请联系管理员');
      } else {
        next();
      }
    },
  },
  {
    path: '/logInquiry',
    name: 'logInquiry',
    component: () => import('@/views/Search/LogInquiry/index.vue'),
    meta: {
      title: '日志查询',
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  // scrollBehavior(to, from, savedPosition) {
  //   console.log('savedPosition', savedPosition);
  //   if (savedPosition) {
  //     return savedPosition;
  //   } else {
  //     return { top: 0 };
  //   }
  // },
});

router.beforeEach((to, from, next) => {
  const publicRouteNames = ['login', 'register'];

  if (to.meta.title) {
    document.title = to.meta.title;
  }
  // 查看工序明细时，标题随着工序变化
  if (to.query.title) {
    document.title = to.query.title;
  }

  // 判断是否登录
  if (!publicRouteNames.includes(to.name) && !sessionStorage.getItem('token')) {
    next({ name: 'login' });
  } else {
    next();
  }
});

// todo 缓存回到上一页，滚动条没有被缓存
router.afterEach((to, from) => {
  // 列表页如果有下一级页面时，先缓存
  if (to.meta?.needKeepAlivePaths?.length) {
    store.commit('addCachePage', to?.meta?.comName);
  }
  // 路由跳转时判断是否进入下一级页面
  if (from.meta.needKeepAlivePaths && from.meta.needKeepAlivePaths.length) {
    const needKeepAlivePaths = from.meta.needKeepAlivePaths;
    if (needKeepAlivePaths.includes(to.path)) {
      store.commit('addCachePage', from.meta.comName);
    } else {
      store.commit('deleteCachePage', from.meta.comName);
    }
  }
});

export default router;
